import { Box, FormControlLabel, Switch, Typography } from "@mui/material";
import * as React from "react";
import { useTranslation } from "react-i18next";

type NotificationsHeaderProps = {
  onlyUnread: boolean;
  setOnlyUnread: (arg0: boolean) => void;
};

export const NotificationsHeader: React.FC<NotificationsHeaderProps> = ({ onlyUnread, setOnlyUnread }) => {
  const { t } = useTranslation();

  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        padding: "12px 16px 12px 16px",
      }}
    >
      <Typography
        sx={{
          fontSize: "24px",
          lineHeight: "32px",
          fontWeight: "600",
          color: "var(--green-grey-scale-900)",
        }}
      >
        {t("notifications.Notifications")}
      </Typography>
      <FormControlLabel
        control={
          <Switch checked={onlyUnread} onChange={event => setOnlyUnread(event.target.checked)} color="primary" />
        }
        label={t("notifications.Show_unread_only")}
        labelPlacement="start"
      />
    </Box>
  );
};
